import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../../../../Constants";
import NavHeightAdjust from "../../../../../../components/navbar/NavHeightAdjust";

const AddDevice = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const buildingId = searchParams.get("buildingId") || "";
  const buildingSite = searchParams.get("buildingSite") || "";
  const address = searchParams.get("address") || "";

  const [deviceFormData, setDeviceFormData] = useState({
    deviceId: "",
    deviceType: "elevator", // Default value for dropdown
    deviceStatus: "",
    buildingId: buildingId,
    buildingSite: buildingSite,
    address: address,
    cat1Insp: "", // New field
    cat5Insp: "", // New field
    periodicInsp: "", // New field
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDeviceFormData({
      ...deviceFormData,
      [name]: value,
    });
  };

  // Function to handle saving the device data
  const handleSave = async () => {
    try {
      const response = await fetch(
        API_BASE_URL + "/api/setup/buildings/devices",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(deviceFormData),
        }
      );

      if (response.ok) {
        alert("Device added successfully!");
        navigate(`/setup/buildings/`);
      } else {
        const errorMessage = await response.text();
        throw new Error(`Failed to add device: ${errorMessage}`);
      }
    } catch (error) {
      console.error("Error adding device:", error);
      alert("An error occurred while adding the device.");
    }
  };

  // Function to handle clearing the form and returning to the view building page
  const handleClear = () => {
    navigate(`/setup/buildings/`);
  };

  return (
    <NavHeightAdjust>
      <div className="w-full mx-auto mt-10 p-8 bg-white rounded-xl shadow-md">
        <h2 className="text-2xl font-bold mb-6">Device Entry and Edit</h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-20">
          {/* Device Information Section */}
          <div className="border-2 border-gray-300 p-4 rounded-md bg-gray-50 grid col-span-2">
            <h3 className="font-semibold text-lg mb-3 text-blue-600">
              Device Information
            </h3>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">Device ID</label>
              <input
                type="text"
                name="deviceId"
                placeholder="Enter Device ID"
                value={deviceFormData.deviceId}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md p-2 mt-1"
              />
            </div>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">Device Type</label>
              <select
                name="deviceType"
                value={deviceFormData.deviceType}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md p-2 mt-1"
              >
                <option value="elevator">Elevator</option>
              </select>
            </div>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">Device Status</label>
              <input
                type="text"
                name="deviceStatus"
                placeholder="Enter Device Status"
                value={deviceFormData.deviceStatus}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md p-2 mt-1"
              />
            </div>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">Building ID</label>
              <input
                type="text"
                name="buildingId"
                value={deviceFormData.buildingId}
                readOnly
                className="border border-gray-300 rounded-md p-2 mt-1 bg-gray-100"
              />
            </div>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">Building Site</label>
              <input
                type="text"
                name="buildingSite"
                value={deviceFormData.buildingSite}
                readOnly
                className="border border-gray-300 rounded-md p-2 mt-1 bg-gray-100"
              />
            </div>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">Address</label>
              <input
                type="text"
                name="address"
                value={deviceFormData.address}
                readOnly
                className="border border-gray-300 rounded-md p-2 mt-1 bg-gray-100"
              />
            </div>
          </div>

          {/* Inspection Dates Section */}
          <div className="border-2 border-gray-300 p-4 rounded-md mt-6 lg:mt-0">
            <h3 className="font-semibold text-lg mb-3 text-blue-600">
              Inspection Dates
            </h3>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">
                Category 1 Inspection
              </label>
              <input
                type="text"
                name="cat1Insp"
                placeholder="Enter Category 1 Inspection Date"
                value={deviceFormData.cat1Insp}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md p-2 mt-1"
              />
            </div>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">
                Category 5 Inspection
              </label>
              <input
                type="text"
                name="cat5Insp"
                placeholder="Enter Category 5 Inspection Date"
                value={deviceFormData.cat5Insp}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md p-2 mt-1"
              />
            </div>
            <div className="flex flex-col mb-4">
              <label className="text-gray-700 font-medium">
                Periodic Inspection
              </label>
              <input
                type="text"
                name="periodicInsp"
                placeholder="Enter Periodic Inspection Date"
                value={deviceFormData.periodicInsp}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md p-2 mt-1"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-4 mt-6">
          <button
            onClick={handleSave}
            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Save
          </button>
          <button
            onClick={handleClear}
            className="px-6 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
          >
            Clear
          </button>
        </div>
      </div>
    </NavHeightAdjust>
  );
};

export default AddDevice;
